"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRegisterVersions = class UcRegisterVersions extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    register;
    onRegister(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("register");
    }
    ux;
    b_5962862420439144_paging;
    b_5962862420439144_sortable;
    b_5962862420439144_rowTemplate;
    async $$load_b_5962862420439144_rowTemplate() {
        return {
            register_id: this.register.id,
        };
    }
    b_5962862420439144_columns;
    dataMembers = ['ux', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_rowTemplate', 'b_5962862420439144_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
                b_5962862420439144_paging: false,
                b_5962862420439144_sortable: false,
                b_5962862420439144_rowTemplate: null,
                b_5962862420439144_columns: [{
                        name: "name",
                        header: this.$fn.pgettext("RegisterVersion", "Name"),
                        width: "110px",
                        required: true,
                    },
                    {
                        name: "financial_year",
                        width: "70px",
                        header: this.$fn.pgettext("RegisterVersion", "Financial year"),
                        type: "number",
                        textAlign: "right",
                        required: true,
                    },
                    {
                        name: "number_format",
                        width: "130px",
                        header: this.$fn.pgettext("RegisterVersion", "Number format"),
                        type: "textarea",
                        required: true,
                    },
                    {
                        name: "current_value",
                        width: "80px",
                        header: this.$fn.pgettext("RegisterVersion", "Current value"),
                        type: "number",
                        textAlign: "right",
                        required: true,
                    },
                    {
                        name: "increment",
                        width: "80px",
                        header: this.$fn.pgettext("RegisterVersion", "Increment"),
                        type: "number",
                        textAlign: "right",
                        required: true,
                    },
                ],
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8082_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('register_version').upsert($event.data.row));
    }
    async act_5962862420439144_script_8082_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8082_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_save(event, scope) {
        return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_emit_8084_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5962862420439144_saveCompleted(event, scope) {
        return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8086_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('invoice_line_meter_accounting').delete($event.data.row));
    }
    async act_5962862420439144_script_8086_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8086_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_delete(event, scope) {
        return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_emit_8088_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5962862420439144_deleteCompleted(event, scope) {
        return await this.actions.evh_5962862420439144_deleteCompleted.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8080 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8079 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8080,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8079],
        });
        const act_5962862420439144_script_8082 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8082_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_save_8081 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8082,
            event: "save",
            displayName: "script",
        });
        const evh_5962862420439144_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_save_8081],
        });
        const act_5962862420439144_emit_8084 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_8084_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_saveCompleted_8083 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_8084,
            event: "save-completed",
            displayName: "emit",
        });
        const evh_5962862420439144_saveCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_saveCompleted_8083],
        });
        const act_5962862420439144_script_8086 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8086_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_delete_8085 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8086,
            event: "delete",
            displayName: "script",
        });
        const evh_5962862420439144_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_delete_8085],
        });
        const act_5962862420439144_emit_8088 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_8088_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_deleteCompleted_8087 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_8088,
            event: "delete-completed",
            displayName: "emit",
        });
        const evh_5962862420439144_deleteCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_deleteCompleted_8087],
        });
        return {
            act_7315092382398562_reloadComponentData_8080,
            evh_7315092382398562_reload_8079,
            evh_7315092382398562_reload,
            act_5962862420439144_script_8082,
            evh_5962862420439144_save_8081,
            evh_5962862420439144_save,
            act_5962862420439144_emit_8084,
            evh_5962862420439144_saveCompleted_8083,
            evh_5962862420439144_saveCompleted,
            act_5962862420439144_script_8086,
            evh_5962862420439144_delete_8085,
            evh_5962862420439144_delete,
            act_5962862420439144_emit_8088,
            evh_5962862420439144_deleteCompleted_8087,
            evh_5962862420439144_deleteCompleted,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcRegisterVersions.prototype, "register", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('register'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterVersions.prototype, "onRegister", null);
UcRegisterVersions = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRegisterVersions);
exports.default = UcRegisterVersions;
vue_property_decorator_1.Vue.component("UcRegisterVersions", UcRegisterVersions);
